import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-738b5152")

_pushScopeId("data-v-738b5152")
const _hoisted_1 = { class: "top-button-group flex alignC" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增工单", -1)
const _hoisted_3 = { class: "mar-t-12" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "开单时间", -1)
const _hoisted_5 = { class: "mar-t-12" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "状态", -1)
const _hoisted_7 = { class: "mar-t-12" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "服务类型", -1)
const _hoisted_9 = { class: "mar-t-12" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "单位", -1)
const _hoisted_11 = { class: "mar-t-12" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "合作方", -1)
const _hoisted_13 = { class: "mar-t-12" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "接车人", -1)
const _hoisted_15 = { class: "mar-t-12" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "车型", -1)
const _hoisted_17 = { class: "mar-t-12 mar-l-16" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "导出", -1)
const _hoisted_19 = { class: "flex flexC" }
const _hoisted_20 = {
  key: 0,
  class: "view-cirle"
}
const _hoisted_21 = { class: "flex flexC button-group" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "c-ff f-12" }, "修改", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "其他成本", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "审核", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "反审核", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "质检审核", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "质检反审核", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "作废", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "恢复", -1)
const _hoisted_30 = { class: "flex flexR mar-t-22" }
const _hoisted_31 = { class: "flex flexR" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "打印报价单", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "工单预收款", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "车辆信息", -1)
const _hoisted_35 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_36 = { class: "flex flexC alignC" }
const _hoisted_37 = /*#__PURE__*/_createVNode("span", { class: "c-30 mar-r-8" }, "车牌", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "arrow" }, [
  /*#__PURE__*/_createVNode("i")
], -1)
const _hoisted_39 = { class: "city-select absolute bg-ff" }
const _hoisted_40 = { class: "flex flexSb alignC mar-b-16" }
const _hoisted_41 = { class: "flex" }
const _hoisted_42 = {
  key: 0,
  class: "select-city-text mar-r-18 text-center"
}
const _hoisted_43 = {
  key: 0,
  class: "flex"
}
const _hoisted_44 = {
  key: 1,
  class: "flex"
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  key: 0,
  class: "flex flexC alignC bg-f2 add-car mar-t-12"
}
const _hoisted_47 = { class: "w-500" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "w-500 c-red mar-l-2" }, "点击查看", -1)
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "w-500" }
const _hoisted_51 = { class: "flex flexC alignC add-car mar-t-12" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "mar-r-18 c-30 w-500" }, "请选择以上车辆，或为该车牌添加新的车辆", -1)
const _hoisted_53 = {
  key: 2,
  class: "add-car flex flexC bg-f2 mar-t-12"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "mar-r-18 c-30 w-500" }, "该车牌暂无车辆信息，请添加车辆", -1)
const _hoisted_55 = {
  key: 1,
  style: {"width":"400px","margin":"0 auto","padding":"30px 0"}
}
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "查找车型", -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增", -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "返回", -1)
const _hoisted_59 = { class: "cost" }
const _hoisted_60 = { class: "flex flexC alignC mar-b-20 relative" }
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增其他成本", -1)
const _hoisted_62 = { class: "c-30 f-20" }
const _hoisted_63 = /*#__PURE__*/_createVNode("span", { class: "c-ff f-12" }, "删除", -1)
const _hoisted_64 = { class: "flex flexC add-cost-form" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" 自动生成采购应付款 ")
const _hoisted_66 = { class: "flex" }
const _hoisted_67 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "取 消", -1)
const _hoisted_69 = { class: "text-center f-14 bold" }
const _hoisted_70 = {
  style: {"margin":"0 auto","padding":"30px 0","width":"600px"},
  class: "mar-t-12"
}
const _hoisted_71 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_72 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_73 = { class: "dialog-content" }
const _hoisted_74 = { class: "dialog-nav flex mar-b-10" }
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_77 = { class: "flex flexC form-button" }
const _hoisted_78 = /*#__PURE__*/_createVNode("span", { class: "c-ff w-500" }, "确定", -1)
const _hoisted_79 = /*#__PURE__*/_createVNode("span", { class: "c-60 w-500" }, "取 消", -1)
const _hoisted_80 = { class: "print" }
const _hoisted_81 = { class: "header" }
const _hoisted_82 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_83 = { class: "store_name" }
const _hoisted_84 = {
  key: 0,
  class: "store"
}
const _hoisted_85 = /*#__PURE__*/_createVNode("div", { class: "name" }, " 扫码关注公众号 ", -1)
const _hoisted_86 = { class: "qrcode" }
const _hoisted_87 = /*#__PURE__*/_createVNode("div", { class: "title flex-1" }, " 车辆维修工时配件报价单 ", -1)
const _hoisted_88 = { class: "body" }
const _hoisted_89 = { class: "order-head flex alignC" }
const _hoisted_90 = { class: "ordersn flex-1" }
const _hoisted_91 = { class: "time" }
const _hoisted_92 = { class: "order-info" }
const _hoisted_93 = /*#__PURE__*/_createVNode("th", null, "车牌号码：", -1)
const _hoisted_94 = /*#__PURE__*/_createVNode("th", null, "车型：", -1)
const _hoisted_95 = /*#__PURE__*/_createVNode("th", null, "车架号：", -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("th", null, "送修人；", -1)
const _hoisted_97 = /*#__PURE__*/_createVNode("th", null, "联系电话：", -1)
const _hoisted_98 = /*#__PURE__*/_createVNode("th", null, "服务类型：", -1)
const _hoisted_99 = /*#__PURE__*/_createVNode("th", null, "进厂时间：", -1)
const _hoisted_100 = /*#__PURE__*/_createVNode("th", null, "进厂里程：", -1)
const _hoisted_101 = /*#__PURE__*/_createVNode("th", null, "接车人：", -1)
const _hoisted_102 = /*#__PURE__*/_createVNode("th", null, "送修单位：", -1)
const _hoisted_103 = {
  key: 0,
  class: "project-table",
  border: "1",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_104 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "序号"),
    /*#__PURE__*/_createVNode("th", { width: "50%" }, "维修项目"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "数量"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "单价"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "金额")
  ])
], -1)
const _hoisted_105 = /*#__PURE__*/_createVNode("th", null, null, -1)
const _hoisted_106 = {
  colspan: "4",
  class: "count"
}
const _hoisted_107 = {
  key: 1,
  class: "parts-table",
  border: "1",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_108 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "序号"),
    /*#__PURE__*/_createVNode("th", { width: "50%" }, "配件名称"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "数量"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "单价"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "金额")
  ])
], -1)
const _hoisted_109 = {
  colspan: "5",
  class: "count"
}
const _hoisted_110 = {
  colspan: "5",
  class: "total"
}
const _hoisted_111 = { class: "other" }
const _hoisted_112 = { class: "info" }
const _hoisted_113 = { class: "item" }
const _hoisted_114 = { class: "item" }
const _hoisted_115 = {
  key: 0,
  class: "store"
}
const _hoisted_116 = /*#__PURE__*/_createVNode("div", { class: "name" }, " 微信扫码支付 ", -1)
const _hoisted_117 = { class: "qrcode" }
const _hoisted_118 = { class: "footer" }
const _hoisted_119 = { class: "address" }
const _hoisted_120 = { class: "telphone" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_PrintForm = _resolveComponent("PrintForm")
  const _directive_loading = _resolveDirective("loading")
  const _directive_print = _resolveDirective("print")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: "bg-ff table-content",
      style: _ctx.isPrint?'padding-bottom: 180px;':''
    }, [
      _createVNode("div", _hoisted_1, [
        (_ctx.roleList.create)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "bg-red mar-r-8 mar-t-12",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.addDialogVisible = true; _ctx.form_status = 0; _ctx.orderCarCode = ''})
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_el_date_picker, {
            class: "mar-l-8",
            type: "daterange",
            modelValue: _ctx.selectGroup.date,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectGroup.date = $event)),
            "range-separator": "-",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束时间",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenChange($event, 'date')))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_el_select, {
            class: "mar-r-8",
            style: {"width":"108px"},
            modelValue: _ctx.selectGroup.orderstatus,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectGroup.orderstatus = $event)),
            placeholder: "请选择",
            clearable: "",
            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectChange($event, 'orderstatus')))
          }, {
            default: _withId(() => [
              _createVNode(_component_el_option, {
                label: "已审核",
                value: "1"
              }),
              _createVNode(_component_el_option, {
                label: "待审核",
                value: "0"
              }),
              _createVNode(_component_el_option, {
                label: "作废",
                value: "-1"
              }),
              _createVNode(_component_el_option, {
                label: "作废",
                value: "-1"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_el_select, {
            class: "mar-r-8",
            style: {"width":"114px"},
            modelValue: _ctx.selectGroup.project_type_id,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectGroup.project_type_id = $event)),
            placeholder: "请选择",
            clearable: "",
            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectChange($event, 'project_type_id')))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.project_type_data, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item.basicset_name,
                  value: item.basicset_id,
                  key: item.basicset_id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_el_select, {
            class: "mar-r-8",
            style: {"width":"114px"},
            modelValue: _ctx.selectGroup.units_id,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectGroup.units_id = $event)),
            placeholder: "请选择",
            clearable: "",
            filterable: "",
            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectChange($event, 'units_id')))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.repairunit_data, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item.repair_unit_name,
                  value: item.repair_unit_id,
                  key: item.repair_unit_id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_el_select, {
            class: "mar-r-8",
            style: {"width":"114px"},
            modelValue: _ctx.selectGroup.partner_id,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectGroup.partner_id = $event)),
            placeholder: "请选择",
            clearable: "",
            filterable: "",
            "value-key": "id",
            onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectChange($event, 'partner_id')))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.partner_data, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item.name,
                  value: item.id,
                  key: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_el_select, {
            class: "mar-r-8",
            style: {"width":"114px"},
            modelValue: _ctx.selectGroup.meet_vehicle,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectGroup.meet_vehicle = $event)),
            placeholder: "请选择",
            clearable: "",
            filterable: "",
            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectChange($event, 'meet_vehicle')))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.receive_data, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item.nickname,
                  value: item.id,
                  key: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_el_select, {
            class: "mar-r-8",
            modelValue: _ctx.selectGroup.car_brand_id,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectGroup.car_brand_id = $event)),
            style: {"width":"108px"},
            clearable: "",
            filterable: "",
            placeholder: "请选择",
            onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectChange($event, 'car_brand_id')))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_brand_data, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item.brand_name,
                  value: item.id,
                  key: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_select, {
            class: "mar-r-18",
            modelValue: _ctx.selectGroup.car_series_id,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectGroup.car_series_id = $event)),
            placeholder: "请选择",
            style: {"width":"132px"},
            disabled: !_ctx.selectGroup.car_brand_id,
            onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.selectChange($event, 'car_series_id')))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_series_data, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item.series_name,
                  value: item.id,
                  key: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_el_input, {
            style: {"width":"230px"},
            modelValue: _ctx.selectGroup.search,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.selectGroup.search = $event)),
            placeholder: "单据编号/车牌/送修人/手机号",
            clearable: "",
            "suffix-icon": "el-icon-search",
            onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.selectChange($event, 'search')))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            class: "mar-l-9 bg-red",
            onClick: _ctx.exportChange
          }, {
            default: _withId(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass,
        "show-summary": "",
        "summary-method": _ctx.getSummariesTable
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "单据编号",
            align: "center",
            "min-width": "120"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_19, [
                _createVNode("div", {
                  class: "c-red ordersn",
                  onClick: ($event: any) => (_ctx.getOrderCarinfo(scope.row.id))
                }, _toDisplayString(scope.row.ordersn), 9, ["onClick"]),
                (scope.row.is_pre==1)
                  ? (_openBlock(), _createBlock("div", _hoisted_20, " 预 "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "240"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_21, [
                (_ctx.roleList.edit && scope.row.button.edit)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "bg-red",
                      onClick: ($event: any) => (_ctx.columnChange(scope.row, 0))
                    }, {
                      default: _withId(() => [
                        _hoisted_22
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.roleList.other_cost && scope.row.button.other_cost)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      onClick: ($event: any) => (_ctx.columnChange(scope.row, 1))
                    }, {
                      default: _withId(() => [
                        _hoisted_23
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.roleList.check && scope.row.button.check)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      onClick: ($event: any) => (_ctx.columnChange(scope.row, 2, 1))
                    }, {
                      default: _withId(() => [
                        _hoisted_24
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.roleList.recheck && scope.row.button.recheck)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 3,
                      onClick: ($event: any) => (_ctx.columnChange(scope.row, 2, 2))
                    }, {
                      default: _withId(() => [
                        _hoisted_25
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.roleList.quality_check && scope.row.button.quality_check)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 4,
                      onClick: ($event: any) => (_ctx.columnChange(scope.row, 3, 1))
                    }, {
                      default: _withId(() => [
                        _hoisted_26
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.roleList.quality_recheck && scope.row.button.quality_recheck)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 5,
                      onClick: ($event: any) => (_ctx.columnChange(scope.row, 3, 2))
                    }, {
                      default: _withId(() => [
                        _hoisted_27
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.roleList.void && scope.row.button.void)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 6,
                      onClick: ($event: any) => (_ctx.columnChange(scope.row, 2, -1))
                    }, {
                      default: _withId(() => [
                        _hoisted_28
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.roleList.recovery && scope.row.button.recovery)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 7,
                      onClick: ($event: any) => (_ctx.columnChange(scope.row, 2, 0))
                    }, {
                      default: _withId(() => [
                        _hoisted_29
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style", "summary-method"]), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode("div", _hoisted_30, [
        _createVNode(_component_el_pagination, {
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange,
          "current-page": _ctx.currentPage,
          "page-sizes": [10, 20,50,100],
          "page-size": _ctx.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total
        }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
      ]),
      _createVNode(_component_el_dialog, {
        title: "工单详情",
        modelValue: _ctx.dialogFormVisible,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.dialogFormVisible = $event)),
        onClosed: _ctx.handleClose,
        center: "",
        width: 1000
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_31, [
            _withDirectives(_createVNode(_component_el_button, { onClick: _ctx.bindPrint }, {
              default: _withId(() => [
                _hoisted_32
              ]),
              _: 1
            }, 8, ["onClick"]), [
              [_directive_print, _ctx.printData]
            ]),
            (_ctx.roleList.advance)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  onClick: _ctx.preparePayClick
                }, {
                  default: _withId(() => [
                    _hoisted_33
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, { onClick: _ctx.getCarInfo }, {
              default: _withId(() => [
                _hoisted_34
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode("table", _hoisted_35, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailTable, (items, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                  return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
                }), 128))
              ]))
            }), 128))
          ]),
          (_ctx.orderDetail.order_offer_project.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 0,
                data: _ctx.orderDetail.order_offer_project,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 1),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_table_column, {
                    label: "序号",
                    align: "center",
                    "min-width": "80"
                  }, {
                    default: _withId((scope) => [
                      _createVNode("div", null, _toDisplayString(scope.$index+1), 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true),
          (_ctx.orderDetail.order_offer_mountings.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 1,
                data: _ctx.orderDetail.order_offer_mountings,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 2),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_table_column, {
                    label: "序号",
                    align: "center",
                    "min-width": "80"
                  }, {
                    default: _withId((scope) => [
                      _createVNode("div", null, _toDisplayString(scope.$index+1), 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partsColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true),
          (_ctx.orderDetail.mountings_cost.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 2,
                data: _ctx.orderDetail.mountings_cost,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 3),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_table_column, {
                    label: "序号",
                    align: "center",
                    "min-width": "80"
                  }, {
                    default: _withId((scope) => [
                      _createVNode("div", null, _toDisplayString(scope.$index+1), 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mountingsCostColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true),
          (_ctx.orderDetail.else_cost.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 3,
                data: _ctx.orderDetail.else_cost,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 4),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elseCostColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true),
          (_ctx.orderDetail.settlement.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 4,
                data: _ctx.orderDetail.settlement,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 5),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settlementColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onClosed"]),
      _createVNode(_component_el_dialog, {
        title: "新增工单",
        modelValue: _ctx.addDialogVisible,
        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.addDialogVisible = $event)),
        center: "",
        width: 1000
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_36, [
            _hoisted_37,
            _createVNode("div", {
              class: "car-city mar-r-8 relative",
              onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.citySelect = true), ["stop"]))
            }, [
              _createVNode("span", null, _toDisplayString(_ctx.carCity), 1),
              _hoisted_38,
              _withDirectives(_createVNode("div", _hoisted_39, [
                _createVNode("div", _hoisted_40, [
                  _createVNode("span", null, _toDisplayString(_ctx.provinceText ? "选择车牌所属城市" : "选择车牌所属省份"), 1),
                  _createVNode("div", _hoisted_41, [
                    (_ctx.provinceText)
                      ? (_openBlock(), _createBlock("p", _hoisted_42, _toDisplayString(_ctx.provinceText), 1))
                      : _createCommentVNode("", true),
                    _createVNode("div", {
                      class: "close-icon relative",
                      onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.citySelect = false), ["stop"]))
                    })
                  ])
                ]),
                (!_ctx.provinceText)
                  ? (_openBlock(), _createBlock("div", _hoisted_43, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.provinceList, (item) => {
                        return (_openBlock(), _createBlock("p", {
                          class: "select-city-text mar-b-10 mar-r-8 text-center",
                          key: item,
                          onClick: ($event: any) => (_ctx.provinceText = item)
                        }, _toDisplayString(item), 9, ["onClick"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_44, [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList('ABCDEFGHIJKLNMOPQRSTUVWXYZ', (item) => {
                        return _createVNode("p", {
                          class: "select-city-text mar-b-10 mar-r-8 text-center",
                          key: item,
                          onClick: _withModifiers(($event: any) => (_ctx.setCarCity(item)), ["stop"])
                        }, _toDisplayString(item), 9, ["onClick"])
                      }), 64))
                    ]))
              ], 512), [
                [_vShow, _ctx.citySelect]
              ])
            ]),
            _createVNode(_component_el_input, {
              style: {"width":"80px"},
              modelValue: _ctx.orderCarCode,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.orderCarCode = $event)),
              onInput: _ctx._dialogCarcode
            }, null, 8, ["modelValue", "onInput"])
          ]),
          (_ctx.form_status == 1)
            ? (_openBlock(), _createBlock("div", _hoisted_45, [
                (_ctx.carList.order_count > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_46, [
                      _createVNode("div", _hoisted_47, _toDisplayString(_ctx.form_carcode) + " 还有 " + _toDisplayString(_ctx.carList.order_count) + " 条未结算工单", 1),
                      _hoisted_48
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.carList.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_49, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.carList, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: item,
                          onClick: ($event: any) => (_ctx._form_addcar(index)),
                          class: "flex flexC alignC bg-f2 add-car mar-t-12"
                        }, [
                          _createVNode("div", _hoisted_50, _toDisplayString(item.code) + " | " + _toDisplayString(item.model_name) + " | 会员号:" + _toDisplayString(item.user_text), 1)
                        ], 8, ["onClick"]))
                      }), 128)),
                      _createVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createVNode("div", {
                          class: "c-red mar-r-8 w-500",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx._form_addcar(null)))
                        }, "添加车辆")
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_53, [
                      _hoisted_54,
                      _createVNode("div", {
                        class: "c-red mar-r-8 w-500",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx._form_addcar(null)))
                      }, "添加车辆")
                    ]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.form_status == 2 || _ctx.form_status == 3)
            ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_55, [
                _createVNode(_component_el_form, {
                  ref: "formRef",
                  model: _ctx.form,
                  rules: _ctx.form_rules,
                  "label-width": "100px"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "" }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.form_carcode), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      prop: "service_type_id",
                      label: "服务类型"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.form.service_type_id,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.form.service_type_id = $event)),
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.project_type_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.basicset_name,
                                value: item.basicset_id,
                                key: item.basicset_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "VIN" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_col, { span: 11 }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.form.vin,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.form.vin = $event)),
                              placeholder: "请输入VIN"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 11 }, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              class: "mar-l-8",
                              onClick: _ctx.checkVinInfo
                            }, {
                              default: _withId(() => [
                                _hoisted_56
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "品牌车型" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_col, { span: 11 }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { prop: "car_brand_id" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  class: "mar-r-8",
                                  modelValue: _ctx.form.car_brand_id,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.form.car_brand_id = $event)),
                                  style: {"width":"108px"},
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择",
                                  onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.selectChange($event, 'car_brand_id_a')))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_brand_data, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        label: item.brand_name,
                                        value: item.id,
                                        key: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 11 }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { prop: "car_series_id" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  class: "mar-r-18",
                                  modelValue: _ctx.form.car_series_id,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.form.car_series_id = $event)),
                                  placeholder: "请选择",
                                  style: {"width":"132px"},
                                  disabled: !_ctx.form.car_brand_id
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_series_data_a, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        label: item.series_name,
                                        value: item.id,
                                        key: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "所属单位" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          modelValue: _ctx.form.units_id,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.form.units_id = $event)),
                          class: "width-86",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.repairunit_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.repair_unit_name,
                                value: item.repair_unit_id,
                                key: item.repair_unit_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "送修人" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.send_for_repair,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.form.send_for_repair = $event)),
                          placeholder: "请输入送修人"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "送修人手机" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.phone,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.form.phone = $event)),
                          placeholder: "请输入"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "合作方" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          modelValue: _ctx.form.partner_id,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.form.partner_id = $event)),
                          class: "width-86",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.partner_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: item.id,
                                key: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "保险公司" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          modelValue: _ctx.form.insurance_company_id,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.form.insurance_company_id = $event)),
                          class: "width-86",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.insurance_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: item.id,
                                key: item.basicset_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "商业险公司" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_col, { span: 11 }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  filterable: "",
                                  modelValue: _ctx.form.cicompany_id,
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.form.cicompany_id = $event)),
                                  class: "width-86",
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.insurance_data, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        label: item.name,
                                        value: item.id,
                                        key: item.basicset_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 11 }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "商业险到期" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_date_picker, {
                                  style: {"width":"208px"},
                                  modelValue: _ctx.form.ccidue_text,
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.form.ccidue_text = $event)),
                                  placeholder: "请选择商业险到期时间",
                                  onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.timeChange($event,'ccidue')))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "交强险公司" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_col, { span: 11 }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  filterable: "",
                                  modelValue: _ctx.form.jicompany_id,
                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.form.jicompany_id = $event)),
                                  class: "width-86",
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.insurance_data, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        label: item.name,
                                        value: item.id,
                                        key: item.basicset_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 11 }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "交强险到期" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_date_picker, {
                                  style: {"width":"208px"},
                                  modelValue: _ctx.form.compulsory_insurance_due_text,
                                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.form.compulsory_insurance_due_text = $event)),
                                  placeholder: "请选择交强险到期时间",
                                  onChange: _cache[41] || (_cache[41] = ($event: any) => (_ctx.timeChange($event,'compulsory_insurance_due')))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "进厂里程" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.mitplant,
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.form.mitplant = $event)),
                          placeholder: "请输入进厂里程"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "接车人",
                      prop: "meet_vehicle_id"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          modelValue: _ctx.form.meet_vehicle_id,
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.form.meet_vehicle_id = $event)),
                          class: "width-86",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.receive_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.nickname,
                                value: item.id,
                                key: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "施工人" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.constructorDialog=true))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.form.constructors_name), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "推荐人" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          modelValue: _ctx.form.recommend_id,
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.form.recommend_id = $event)),
                          class: "width-86",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.receive_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.nickname,
                                value: item.id,
                                key: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "检车分组",
                      prop: ""
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.form.car_check_id,
                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.form.car_check_id = $event)),
                          class: "width-86",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_check_group, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: item.id,
                                key: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          class: "bg-red",
                          onClick: _ctx._onSubmit
                        }, {
                          default: _withId(() => [
                            _hoisted_57
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.form_status = 0))
                        }, {
                          default: _withId(() => [
                            _hoisted_58
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ], 512)), [
                [_directive_loading, _ctx.form_isload]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "新增其他成本",
        modelValue: _ctx.costDialogVisible,
        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_ctx.costDialogVisible = $event)),
        center: "",
        width: 1000
      }, {
        default: _withId(() => [
          _withDirectives(_createVNode("div", _hoisted_59, [
            _createVNode("div", _hoisted_60, [
              _createVNode(_component_el_button, {
                class: "bg-red mar-r-8 add-cost absolute",
                onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.isAddCost = true))
              }, {
                default: _withId(() => [
                  _hoisted_61
                ]),
                _: 1
              }),
              _createVNode("p", _hoisted_62, "车牌号码：" + _toDisplayString(_ctx.costDialogCarCode), 1)
            ]),
            _withDirectives(_createVNode(_component_el_table, {
              data: _ctx.costTableData,
              stripe: "",
              style: {"width":"100%"},
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elseCostListColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128)),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  align: "center",
                  "min-width": "80"
                }, {
                  default: _withId((scope) => [
                    _createVNode(_component_el_button, {
                      class: "bg-red",
                      onClick: ($event: any) => (_ctx.deleteElseCost(scope.row.othercosts_id))
                    }, {
                      default: _withId(() => [
                        _hoisted_63
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "header-cell-style"]), [
              [_directive_loading, _ctx.costLoading]
            ])
          ], 512), [
            [_vShow, !_ctx.isAddCost]
          ]),
          _withDirectives(_createVNode("div", _hoisted_64, [
            _createVNode(_component_el_form, {
              ref: "addCostFormRef",
              "label-width": "150px",
              model: _ctx.addCostForm,
              rules: _ctx.costRules
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "成本项目",
                  prop: "othercosts_name"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      class: "add-cost-input",
                      modelValue: _ctx.addCostForm.othercosts_name,
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.addCostForm.othercosts_name = $event)),
                      placeholder: "请输入成本项目"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "成本",
                  prop: "othercosts_costprice"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      class: "add-cost-input",
                      modelValue: _ctx.addCostForm.othercosts_costprice,
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.addCostForm.othercosts_costprice = $event)),
                      placeholder: "请输入成本"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "成本承担部门",
                  prop: "branch_id"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      class: "add-cost-input",
                      modelValue: _ctx.addCostForm.branch_id,
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.addCostForm.branch_id = $event)),
                      placeholder: "请选择成本承担部门"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.branch_data, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.name,
                            value: item.id,
                            key: index
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "供应商",
                  prop: "supplier_id"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      class: "add-cost-input",
                      filterable: "",
                      modelValue: _ctx.addCostForm.supplier_id,
                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (_ctx.addCostForm.supplier_id = $event)),
                      placeholder: "请选择供应商"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.supplier_data, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.supplier_name,
                            value: item.supplier_id,
                            key: index
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "采购员" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      class: "add-cost-input",
                      modelValue: _ctx.addCostForm.admin_id,
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (_ctx.addCostForm.admin_id = $event)),
                      placeholder: "不限制"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.receive_data, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.nickname,
                            value: item.id,
                            key: index
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "生成应付款" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_checkbox, {
                      "true-label": 1,
                      "false-label": 0,
                      modelValue: _ctx.addCostForm.cpayment,
                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (_ctx.addCostForm.cpayment = $event))
                    }, {
                      default: _withId(() => [
                        _hoisted_65
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_66, [
                      _createVNode(_component_el_button, {
                        class: "bg-red mar-r-8",
                        onClick: _ctx.addElseCost
                      }, {
                        default: _withId(() => [
                          _hoisted_67
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.isAddCost = false))
                      }, {
                        default: _withId(() => [
                          _hoisted_68
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ], 512), [
            [_vShow, _ctx.isAddCost]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.preparePayDia_show,
        "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (_ctx.preparePayDia_show = $event)),
        center: "",
        width: "465"
      }, {
        default: _withId(() => [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_69, "车牌号码：" + _toDisplayString(_ctx.orderDetail.car_code), 1),
            _createVNode("div", _hoisted_70, [
              _withDirectives(_createVNode(_component_el_form, {
                ref: "preparePayFormRef",
                model: _ctx.preparePayForm,
                rules: _ctx.prepareFormRules,
                "label-width": "120px"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "预收日期" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.preparePayForm.time,
                        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (_ctx.preparePayForm.time = $event)),
                        "value-format": "x",
                        readonly: "true"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "收款方式",
                    prop: ""
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.preparePayForm.payTypeOne,
                        "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (_ctx.preparePayForm.payTypeOne = $event)),
                        placeholder: "请选择",
                        clearable: "",
                        class: "mar-r-8",
                        style: {"width":"154px"}
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.zf, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.basicset_name,
                              value: item.basicset_id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_input, {
                        placeholder: "输入金额",
                        modelValue: _ctx.preparePayForm.priceOne,
                        "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (_ctx.preparePayForm.priceOne = $event)),
                        class: "width-100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "收款方式" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.preparePayForm.payTypeTwo,
                        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (_ctx.preparePayForm.payTypeTwo = $event)),
                        placeholder: "请选择",
                        clearable: "",
                        class: "mar-r-8",
                        style: {"width":"154px"}
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.zf, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.basicset_name,
                              value: item.basicset_id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_input, {
                        placeholder: "输入金额",
                        modelValue: _ctx.preparePayForm.priceTwo,
                        "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => (_ctx.preparePayForm.priceTwo = $event)),
                        class: "width-100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "预收款备注" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        placeholder: "请输入内容",
                        clearable: "",
                        rows: "2",
                        modelValue: _ctx.preparePayForm.desc,
                        "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (_ctx.preparePayForm.desc = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withId(() => [
                      _createVNode(_component_el_button, {
                        class: "bg-red",
                        onClick: _ctx.savePreparePay
                      }, {
                        default: _withId(() => [
                          _hoisted_71
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]), [
                [_directive_loading, _ctx.prepareData.prepareLoad]
              ])
            ]),
            _withDirectives(_createVNode(_component_el_table, {
              data: _ctx.prepareData.prepareList,
              stripe: "",
              style: {"width":"100%"},
              class: "table",
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                _createVNode(_component_el_table_column, {
                  label: "预收日期",
                  align: "center",
                  "min-width": "80",
                  prop: "pay_time_text"
                }),
                _createVNode(_component_el_table_column, {
                  label: "金额",
                  align: "center",
                  "min-width": "80",
                  prop: "payment_price"
                }),
                _createVNode(_component_el_table_column, {
                  label: "收款方式",
                  align: "center",
                  "min-width": "80",
                  prop: "basicset_name"
                }),
                _createVNode(_component_el_table_column, {
                  label: "备注",
                  align: "center",
                  "min-width": "80",
                  prop: "payment_remarks"
                })
              ]),
              _: 1
            }, 8, ["data", "header-cell-style"]), [
              [_directive_loading, _ctx.prepareData.prepareLoading]
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "车辆信息",
        modelValue: _ctx.carInfoDia_show,
        "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (_ctx.carInfoDia_show = $event)),
        onClosed: _ctx.handleClose,
        center: "",
        width: 1000,
        "append-to-body": "true"
      }, {
        default: _withId(() => [
          _createVNode("table", _hoisted_72, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.carInfoTable, (items, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                  return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onClosed"]),
      _createVNode(_component_el_dialog, {
        center: "",
        title: "选择默认施工人",
        modelValue: _ctx.constructorDialog,
        "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => (_ctx.constructorDialog = $event)),
        width: "800"
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_73, [
            _createVNode("div", _hoisted_74, [
              _createVNode("p", {
                class: ["mar-r-20", { 'nav-range c-red': _ctx.dialogNavIndex == 0 }],
                onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.dialogNavIndex = 0))
              }, " 部门 ", 2),
              _createVNode("p", {
                onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.dialogNavIndex = 1)),
                class: { 'nav-range c-red': _ctx.dialogNavIndex == 1 }
              }, " 个人 ", 2)
            ]),
            _withDirectives(_createVNode("div", null, [
              _createVNode(_component_el_table, {
                data: _ctx.select.branch_data,
                stripe: "",
                style: {"width":"100%"},
                class: "table",
                "header-cell-style": _ctx.headClass,
                onCurrentChange: _ctx.branchCurrentChange
              }, {
                default: _withId(() => [
                  _hoisted_75,
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "name",
                    label: "部门名称",
                    "min-width": "200"
                  })
                ]),
                _: 1
              }, 8, ["data", "header-cell-style", "onCurrentChange"])
            ], 512), [
              [_vShow, _ctx.dialogNavIndex == 0]
            ]),
            _withDirectives(_createVNode("div", null, [
              _createVNode(_component_el_table, {
                data: _ctx.select.receive_data,
                stripe: "",
                style: {"width":"100%"},
                class: "table",
                "header-cell-style": _ctx.headClass,
                onSelectionChange: _ctx.workersSelectionChange
              }, {
                default: _withId(() => [
                  _hoisted_76,
                  _createVNode(_component_el_table_column, {
                    type: "selection",
                    width: "55"
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "name",
                    label: "姓名"
                  })
                ]),
                _: 1
              }, 8, ["data", "header-cell-style", "onSelectionChange"]),
              _createVNode("div", _hoisted_77, [
                _createVNode(_component_el_button, {
                  class: "bg-red",
                  onClick: _ctx.comfirmClick
                }, {
                  default: _withId(() => [
                    _hoisted_78
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.constructorDialog = false))
                }, {
                  default: _withId(() => [
                    _hoisted_79
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, _ctx.dialogNavIndex == 1]
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 4),
    _withDirectives(_createVNode(_component_PrintForm, { id: "print" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_80, [
          _createVNode("div", _hoisted_81, [
            _hoisted_82,
            _createVNode("div", _hoisted_83, _toDisplayString(_ctx.userInfo.store_name), 1),
            (_ctx.publicImgeUrl)
              ? (_openBlock(), _createBlock("div", _hoisted_84, [
                  _hoisted_85,
                  _createVNode("div", _hoisted_86, [
                    _createVNode("img", {
                      src: _ctx.publicImgeUrl,
                      alt: ""
                    }, null, 8, ["src"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_87
          ]),
          _createVNode("div", _hoisted_88, [
            _createVNode("div", _hoisted_89, [
              _createVNode("div", _hoisted_90, " 单据编号：" + _toDisplayString(_ctx.orderDetail.ordersn), 1),
              _createVNode("div", _hoisted_91, _toDisplayString(_ctx.orderDetail.settlement_time_text), 1)
            ]),
            _createVNode("table", _hoisted_92, [
              _createVNode("tbody", null, [
                _createVNode("tr", null, [
                  _hoisted_93,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.car_code), 1),
                  _hoisted_94,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.series_name), 1),
                  _hoisted_95,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.vin), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_96,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.send_for_repair), 1),
                  _hoisted_97,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.send_for_repair_phone), 1),
                  _hoisted_98,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.basicset_id_name), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_99,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.create_time_text), 1),
                  _hoisted_100,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.mitplant), 1),
                  _hoisted_101,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.meet_vehicle_id_name), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_102,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.units_id_name), 1)
                ])
              ])
            ]),
            (_ctx.isProject)
              ? (_openBlock(), _createBlock("table", _hoisted_103, [
                  _hoisted_104,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderDetail.order_offer_project, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("th", null, _toDisplayString(index+1), 1),
                        _createVNode("th", null, _toDisplayString(item.print_project_name), 1),
                        _createVNode("th", null, _toDisplayString(item.num), 1),
                        _createVNode("th", null, _toDisplayString(item.quoted_price), 1),
                        _createVNode("th", null, _toDisplayString(item.price), 1)
                      ]))
                    }), 128)),
                    _createVNode("tr", null, [
                      _hoisted_105,
                      _createVNode("th", _hoisted_106, "维修工时费小计：￥" + _toDisplayString(_ctx.orderDetail.project_sum_quoted_price), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isMountings)
              ? (_openBlock(), _createBlock("table", _hoisted_107, [
                  _hoisted_108,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderDetail.order_offer_mountings, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("th", null, _toDisplayString(index+1), 1),
                        _createVNode("th", null, _toDisplayString(item.mountings_name), 1),
                        _createVNode("th", null, _toDisplayString(item.num), 1),
                        _createVNode("th", null, _toDisplayString(item.quoted_price), 1),
                        _createVNode("th", null, _toDisplayString(item.price), 1)
                      ]))
                    }), 128)),
                    _createVNode("tr", null, [
                      _createVNode("th", _hoisted_109, "配件费用小计：￥" + _toDisplayString(_ctx.orderDetail.mountings_sum_quoted_price), 1)
                    ]),
                    _createVNode("tr", null, [
                      _createVNode("th", _hoisted_110, "报价金额：￥" + _toDisplayString(_ctx.orderDetail.offer_price), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_111, [
              _createVNode("div", _hoisted_112, [
                _createVNode("div", _hoisted_113, " 客　户：" + _toDisplayString(_ctx.orderDetail.user_name), 1),
                _createVNode("div", _hoisted_114, " 接车员：" + _toDisplayString(_ctx.orderDetail.meet_vehicle_id_name), 1)
              ]),
              (_ctx.qrcodeImgeUrl&&_ctx.orderDetail.orderstatus==4)
                ? (_openBlock(), _createBlock("div", _hoisted_115, [
                    _hoisted_116,
                    _createVNode("div", _hoisted_117, [
                      _createVNode("img", {
                        src: _ctx.qrcodeImgeUrl,
                        alt: ""
                      }, null, 8, ["src"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_118, [
              _createVNode("div", _hoisted_119, " 地址：" + _toDisplayString(_ctx.orderDetail.address), 1),
              _createVNode("div", _hoisted_120, " 电话：" + _toDisplayString(_ctx.orderDetail.service_phone), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.isPrint]
    ])
  ], 64))
})